import { createUseStyles } from 'react-jss'
import { scrollableList } from '../../../../../styles/common'

const useStyles = createUseStyles({
  listWrapper: {
    display: 'block',
    listStyle: 'none',
    padding: 0,
    extend: scrollableList
  }
})

export default useStyles
